/**
 * 空白チェック
 * @param obj
 */
export function isNotEmpty(obj: unknown) {
  if (obj === null || obj === undefined) {
    return false;
  }
  if (Array.isArray(obj)) {
    return obj.length > 0;
  }
  if (typeof obj === 'string') {
    return obj.length > 0;
  }
  if (typeof obj === 'object') {
    return Object.keys(obj).length > 0;
  }
  return true;
}
